import { merge } from 'cerebral/factories';
import { state, props } from 'cerebral';

export default path => [
  merge(state`${path}.media`, props`media`),
  merge(state`${path}.window`, props`windowSpec`),
];
